
import { useNavigate, Link } from 'react-router-dom';
import { getUser, removeToken } from '../../utils/auth';
import { ArrowRightOnRectangleIcon, BookOpenIcon, LinkIcon } from '@heroicons/react/24/outline';
import toast from 'react-hot-toast';

export default function Navbar({ title = 'EbookStore', subtitle }) {
  const navigate = useNavigate();
  const user = getUser();

  const logout = () => {
    removeToken();
    navigate('/login');
  };

  const copyStoreLink = () => {
    const url = `${window.location.origin}/store/${user.tenant_slug}`;
    navigator.clipboard.writeText(url).then(() => toast.success('Link toko disalin!'));
  };

  return (
    <div className="bg-wa-dark px-4 py-3 flex items-center justify-between shadow-md sticky top-0 z-30">
      <Link to="/" className="flex items-center gap-2 hover:opacity-80 transition">
        {user?.tenant_logo
          ? <img src={user.tenant_logo} className="w-8 h-8 rounded object-cover" alt="logo" />
          : <BookOpenIcon className="w-6 h-6 text-white" />
        }
        <div>
          <span className="text-white font-bold text-lg tracking-wide">{title}</span>
          {subtitle && <p className="text-green-200 text-xs leading-tight">{subtitle}</p>}
        </div>
      </Link>
      <div className="flex items-center gap-3">
        {user && (
          <>
            <Link to="/profile" className="flex items-center gap-2 hover:opacity-80 transition">
              <div className="w-8 h-8 rounded-full bg-wa-green flex items-center justify-center text-white text-sm font-semibold">
                {user.name?.[0]?.toUpperCase() || 'U'}
              </div>
              <span className="text-green-100 text-sm hidden sm:block">{user.name}</span>
            </Link>
            {user.tenant_slug && (
              <button
                onClick={copyStoreLink}
                className="flex items-center gap-1 text-green-100 hover:text-white text-sm font-medium transition"
                title="Salin link toko"
              >
                <LinkIcon className="w-4 h-4" />
                <span className="hidden sm:inline">Link Toko</span>
              </button>
            )}
            <Link
              to="/seller"
              className="text-green-100 hover:text-white text-sm font-medium transition"
            >
              Toko
            </Link>
            <Link
              to="/library"
              className="text-green-100 hover:text-white text-sm font-medium transition"
            >
              Perpustakaan
            </Link>
          </>
        )}
        <button
          onClick={logout}
          className="text-green-200 hover:text-white transition"
          title="Keluar"
        >
          <ArrowRightOnRectangleIcon className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}
